import { Link, useNavigate, NavLink, useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useNavbarScroll } from '../../hooks/useNavbarScroll'
import { useAuth } from '../../hooks/useAuth'
import { supabase } from '../../config/supabase'
import UserMenu from './UserMenu'
import './Navbar.css'

function Navbar() {
  const { user, loading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const navbarRef = useNavbarScroll()
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    setIsAuthenticated(!!user)
  }, [user])

  useEffect(() => {
    // Cerrar menú móvil cuando cambia la ruta
    setIsMobileMenuOpen(false)
  }, [location.pathname])

  useEffect(() => {
    // Prevenir scroll del body cuando el menú móvil está abierto
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isMobileMenuOpen])

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut()
      localStorage.removeItem('token')
      setIsAuthenticated(false)
      setIsMobileMenuOpen(false)
      window.dispatchEvent(new Event('authChange'))
      navigate('/')
    } catch (error) {
      console.error('Error logging out:', error)
      // Limpiar localmente incluso si hay error
      localStorage.removeItem('token')
      setIsAuthenticated(false)
      setIsMobileMenuOpen(false)
      navigate('/')
    }
  }

  const handleNavClick = () => {
    setIsMobileMenuOpen(false)
  }

  return (
    <>
      <nav className="navbar" ref={navbarRef}>
        <div className="navbar-container">
          <Link to="/" className="navbar-logo">
            <img src="/img/logo-prueba.png" alt="The UNFILTERED COLLECTIVE" className="logo-img" />
          </Link>
          
          <div className="navbar-links">
            <NavLink 
              to="/" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              Home
            </NavLink>
            <NavLink 
              to="/about-us" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              About Us
            </NavLink>
            <NavLink 
              to="/pricing" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              Pricing
            </NavLink>
            <NavLink 
              to="/contact" 
              className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
            >
              Contact
            </NavLink>
          </div>
          
          <div className="navbar-right">
            {isAuthenticated ? (
              <>
                <div className="navbar-desktop-menu">
                  <UserMenu onLogout={handleLogout} />
                </div>
                <button 
                  className="mobile-menu-toggle"
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  aria-label="Toggle menu"
                >
                  <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </button>
              </>
            ) : (
              <>
                <div className="auth-buttons">
                  <Link to="/login" className="btn-login">Login</Link>
                  <Link to="/register" className="btn-register">Register</Link>
                </div>
                <button 
                  className="mobile-menu-toggle"
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                  aria-label="Toggle menu"
                >
                  <span className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                </button>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div 
        className={`mobile-menu-overlay ${isMobileMenuOpen ? 'open' : ''}`}
        onClick={() => setIsMobileMenuOpen(false)}
      >
        <div 
          className={`mobile-menu-sidebar ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={(e) => e.stopPropagation()}
        >
          <button 
            className="mobile-menu-close"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path 
                d="M18 6L6 18M6 6L18 18" 
                stroke="var(--color-dorado)" 
                strokeWidth="2" 
                strokeLinecap="round"
              />
            </svg>
          </button>

          <nav className="mobile-nav-links">
            {!isAuthenticated ? (
              <>
                <NavLink 
                  to="/" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  Home
                </NavLink>
                <NavLink 
                  to="/about-us" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  About Us
                </NavLink>
                <NavLink 
                  to="/pricing" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  Pricing
                </NavLink>
                <NavLink 
                  to="/contact" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  Contact
                </NavLink>
                <div className="mobile-auth-buttons">
                  <Link 
                    to="/login" 
                    className="mobile-btn-login"
                    onClick={handleNavClick}
                  >
                    Login
                  </Link>
                  <Link 
                    to="/register" 
                    className="mobile-btn-register"
                    onClick={handleNavClick}
                  >
                    Register
                  </Link>
                </div>
              </>
            ) : (
              <>
                <NavLink 
                  to="/" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  Home
                </NavLink>
                <NavLink 
                  to="/about-us" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  About Us
                </NavLink>
                <NavLink 
                  to="/pricing" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  Pricing
                </NavLink>
                <NavLink 
                  to="/contact" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  Contact
                </NavLink>
                <NavLink 
                  to="/dashboard" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  Dashboard
                </NavLink>
                <NavLink 
                  to="/profile" 
                  className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                  onClick={handleNavClick}
                >
                  Profile
                </NavLink>
                <button 
                  className="mobile-nav-link sign-out"
                  onClick={() => {
                    handleNavClick()
                    handleLogout()
                  }}
                >
                  Sign Out
                </button>
              </>
            )}
          </nav>
        </div>
      </div>
    </>
  )
}

export default Navbar
